import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { GIF_PROVIDER_ID, GifsService } from "./gifs.service";
import { Gif } from "./gif.types";
import { debounceTime, distinctUntilChanged, Subject, switchMap, takeUntil, tap } from "rxjs";
import { TranslateModule } from "@ngx-translate/core";
import { FormBuilder, ReactiveFormsModule } from "@angular/forms";

@Component({
    selector: "tm-gif-picker",
    templateUrl: "./gif-picker.component.html",
    imports: [
        TranslateModule,
        ReactiveFormsModule
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        GifsService
    ]
})
export class TmGifPickerComponent implements OnInit, OnDestroy {

    protected gifs: Gif[] = [];

    protected show: boolean = false;

    protected searchLoading: boolean = false;

    protected searchInputCtrl = this.formBuilder.nonNullable.control<string>('');

    private _destroy$ = new Subject<void>();

    @Output()
    onAddElement: EventEmitter<Gif> = new EventEmitter<Gif>()

    constructor(
        private gifsService: GifsService,
        private formBuilder: FormBuilder,
        @Inject(GIF_PROVIDER_ID) protected gifProvider: string) {}

    ngOnInit() {

        this.searchInputCtrl.valueChanges
            .pipe(
                tap(() => this.searchLoading = true),
                debounceTime(500),
                distinctUntilChanged(),
                switchMap(search => {
                    return this.gifsService.search({ q: search })
                }),
                tap(gifs => {
                    this.gifs = gifs;
                    this.searchLoading = false;
                }),
                takeUntil(this._destroy$)
            ).subscribe();
    }

    showGifs() {
        if (this.gifs && this.gifs.length === 0) {
        this.gifsService.getTrending()
            .pipe(
                tap((gifs) => {
                    this.gifs = gifs;
                }),
                takeUntil(this._destroy$)
            ).subscribe();
        }
        this.show = !this.show;
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    addGif(gif: Gif): void {
        this.onAddElement.next(gif);

        this.gifsService.registerShare({ q: this.searchInputCtrl.value, id: gif.id })
            .pipe(
                takeUntil(this._destroy$)
            ).subscribe();

        this.show = false;
    }
}